import { openNewWindow } from './common';

export const openPostTwitter = (text: string) => {
  openNewWindow(
    `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`,
    '_blank',
    true,
  );
};
